import { logger } from '../../../common/utils/logger';

export const onPopularSearchQueryButtonClicked: () =>
	| {
			action: string;
			actionSubject: string;
			eventType: string;
	  }
	| {
			action?: undefined;
			actionSubject?: undefined;
			eventType?: undefined;
	  } = () => {
	try {
		return {
			action: 'clicked',
			actionSubject: 'popularSearchQueryButton',
			eventType: 'ui',
		};
	} catch (error) {
		logger.error({ error, functionName: 'onPopularSearchQueryButtonClicked' });
		return {};
	}
};
